export function enablePointerEvents() {
  const canvas = document.querySelector('#game-container canvas');
  if (canvas) canvas.style.pointerEvents = 'auto';
}

export function disablePointerEvents() {
  const canvas = document.querySelector('#game-container canvas');
  if (canvas) canvas.style.pointerEvents = 'none';
}
